module.exports = __webpack_public_path__ + "img/linkdinWeavr.d9371c1c.svg";